'use strict';

module.exports = (app) => app.controller('taskRedirectionController', /* @ngInject */ function ($scope, taskService, sseService, orderService, workflowService) {

    const ORDER_PROCESSED_STATUS = {
        REJECTED: 3
    }

    const STATES = {
        PENDING: 0,
        REJECTED: 1,
        TASK_AVAILABLE: 2
    }

    let orderNumber;
    let startTaskCount = 0;


    $scope.init = init;
    $scope.STATES = STATES;
    $scope.state = STATES.PENDING;
    $scope.showTask = false;

    async function init(order) {
        await determineIfTaskNeedsToBeShown();
        if($scope.showTask) {
            orderNumber = order;
            startTaskCount = taskService.currentOpenTaskCount;
            checkIfOrderRejected()
            const iframeRoute = await getRedirectUrl(orderNumber);
            if (iframeRoute) {
                openIframeIn(iframeRoute);
            } else if (startTaskCount !== taskService.currentOpenTaskCount) { // during await operation did change the task count
                init(orderNumber);
            } else {
                window.addEventListener(sseService.IDS.TASK_COUNT, onTaskCountChange)
            }
        }
    }

    async function determineIfTaskNeedsToBeShown() {
        const showTask = await workflowService.showTaskAfterOrderCompletion()
        $scope.showTask = showTask.showTask;
        $scope.$apply();
    }

    function getRedirectUrl(orderNumber) {
        return new Promise((resolve) => {
            taskService.getTasksForOrder(orderNumber).then((taskList) => {
                let iframeRoute;
                if (taskList && taskList.length === 1) {
                    const task = taskList[0];
                    iframeRoute = `client/task/${task.id}/${task.formKey.replace('app:', '')}`;
                } else if (taskList && taskList.length > 1) {
                    iframeRoute = 'client/task/list';
                }

                resolve(iframeRoute);
            }, (e) => {
                console.error(e);
                resolve();
            })
        })
    }

    function onTaskCountChange() {
        getRedirectUrl(orderNumber).then((iframeRoute) => {
            if (iframeRoute) {
                openIframeIn(iframeRoute);
                window.removeEventListener(sseService.IDS.TASK_COUNT, onTaskCountChange);
            }
        });
    }

    function openIframeIn(iframeRoute) {
        $scope.state = STATES.TASK_AVAILABLE;
        window.setIFrameRoute(iframeRoute);
        const targetPath = `container.htm&if=${iframeRoute}`;
        const taskListBreadcrumb = new Breadcrumb(_('Aufgaben listen'), 'fa fa-list', 'container.htm&if=client/task/list', '/client/task/list', []);
        const breadcrumbs = [
            taskListBreadcrumb,
        ];
        window.openContent(targetPath, _('Aufgabe'), null, breadcrumbs);
    }

    function onOrderChange(event) {
        if (event && event.detail && event.detail.orderNumber === orderNumber) {
            checkOrderStatus(event.detail.status);
        }
    }

    function checkIfOrderRejected() {
        window.addEventListener(sseService.IDS.ORDER_CHANGES, onOrderChange);
        orderService.findById(orderNumber).then((order) => {
            if (order && order.status && order.status.id) {
                checkOrderStatus(order.status.id);
            }
        })
    }

    function checkOrderStatus(status) {
        if (+status === ORDER_PROCESSED_STATUS.REJECTED) {
            removeListeners();
            $scope.state = STATES.REJECTED;
            $scope.$apply();
        }
    }

    /**
     * remove event listener on destroy
     */
    $scope.$on('$destroy', removeListeners);

    function removeListeners() {
        window.removeEventListener(sseService.IDS.TASK_COUNT, onTaskCountChange);
        window.removeEventListener(sseService.IDS.ORDER_CHANGES, onOrderChange);
    }

});

